import * as React from 'react';
import * as classes from '@common/components/spinner/spinner.scss';
import { Spinner } from '@common/components';

export const SpinnerPage = () => (
  <div className={['row middle-xs center-xs', classes.spinnerPage].join(' ')}>
    <Spinner />
  </div>
);



// WEBPACK FOOTER //
// ./src/common/components/spinner/spinner-page.component.tsx